import gql from 'graphql-tag';

export const createMOCEventCategory = gql`
  mutation createMOCEventCategory(
    $shiftGroupId: String
    $name: String
    $enabled: Boolean
    $businessUnits: BusinessUnitInput
  ) {
    createMOCEventCategory(
      enabled: $enabled
      name: $name
      shiftGroupId: $shiftGroupId
      businessUnits: $businessUnits
    ) {
      id
      name
      enabled
      createdAt
      createdBy
      updatedAt
      updater
    }
  }
`;
